// extracted by mini-css-extract-plugin
module.exports = {"form_dialogue":"styles_form_dialogue__1RjfT"};